import {
  CircularProgress,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  SvgIcon,
  Tooltip
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import SnackBarBox from '../../components/SnackBarBox';
import { MoreHoriz, MoreVert } from '@mui/icons-material';
import { colorPrimary, colorTextBlack } from '../../config/theme';
import ShareButtonDialog from '../contentManagement/components/ShareButtonDialog';
import ReportModal from '../contentManagement/components/ReportModal';
import { useDispatch } from 'react-redux';
import { addSaveToWatchLater } from '../../redux/reducers/resourcesSlice';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

function MoreActionsComponent({
  data,
  isViewContentPage = false,
  isDisabled = false,
  handleOpenModal,
  path,
  onClick
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [showError, setShowError] = useState(null);
  const [isShareDialogOpen, setIsShareDialogOpen] = useState(false);
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);

  const { authData } = useSelector(state => state.auth);
  const {
    isSaveToWatchLaterLoading,
    isSaveToWatchLaterSuccess,
    isSaveToWatchLaterFailed
  } = useSelector(state => state.resource);

  useEffect(() => {
    if (!isSaveToWatchLaterLoading) {
      setAnchorEl(null);
      setShowError(null);
    }
  }, [
    isSaveToWatchLaterLoading,
    isSaveToWatchLaterSuccess,
    isSaveToWatchLaterFailed
  ]);
  const handleMenuActions = (e, action) => {
    e.stopPropagation();
    setShowError(null);
    if (action === 'Save to watch later' || action === 'Remove from library') {
      handleWatchLater();
    } else if (action === 'Share') {
      if (data?.share) {
        setIsShareDialogOpen(true);
      }
    } else if (action === 'Report') {
      setIsReportDialogOpen(true);
      if (typeof onClick === 'function') {
        onClick();
      }
    }
  };

  const handleWatchLater = () => {
    let payload = {
      contentId: data?.content_id || data?.contentId || 0,
      userId: authData?.userId || 0,
      loggedInUserName: authData?.userName || ''
    };

    let isRemove =
      location?.pathname.includes('/content-space/library') ||
      path?.includes('/content-space/library')
        ? true
        : false;
    dispatch(addSaveToWatchLater({ payload, isRemove }));
  };

  const handleCloseShareDialog = e => {
    // e.stopPropagation();
    setIsShareDialogOpen(false);
  };

  const handleCloseReportDialog = e => {
    if (e) {
      e.stopPropagation();
    }
    setIsReportDialogOpen(false);
    setAnchorEl(null);
  };

  const handleClose = e => {
    e.stopPropagation();
    setAnchorEl(null);
    setShowError(null);
  };

  const viewContentPageMenu = [
    path?.includes('/content-space/library')
      ? 'Remove from library'
      : 'Save to watch later',
    'Report'
  ];

  const allMenus = [
    location.pathname.includes('/content-space/library') ||
    path?.includes('/content-space/library')
      ? 'Remove from library'
      : 'Save to watch later',
    'Share',
    'Report'
  ];

  const pageMenu = isViewContentPage ? viewContentPageMenu : allMenus;
  return (
    <>
      <Tooltip title="More actions">
        {isViewContentPage ? (
          <IconButton
            sx={{
              width: '46px',
              height: '34px',
              border: 'solid #F4C24A 2px',
              borderRadius: '8px',
              color: '#1F2933',
              cursor: 'pointer',
              '&:hover': {
                borderColor: colorPrimary,
                backgroundColor: 'transparent',
                borderRadius: '10px',
                borderWidth: '2px'
              }
            }}
            onClick={event => {
              event.stopPropagation();
              setAnchorEl(event.currentTarget);
            }}
          >
            <MoreHoriz />
          </IconButton>
        ) : (
          <MoreVert
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={event => {
              if (!isDisabled) {
                event.stopPropagation();
                setAnchorEl(event.currentTarget);
              } else {
                handleOpenModal();
              }
            }}
          />
        )}
      </Tooltip>

      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={e => {
          handleClose(e);
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            // width: '20ch',
            // width: '166px',
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 0.5
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {pageMenu.map(option =>
          option === 'Share' && !data?.share ? (
            <Tooltip
              placement="right"
              title="Share for the content is disabled."
              key={option}
            >
              <MenuItem
                key={option}
                onClick={e => {
                  e.stopPropagation();
                  handleMenuActions(e, option);
                }}
                sx={{
                  fontWeight: '600',
                  fontSize: '14px',
                  color: colorTextBlack,
                  '&:hover': {
                    backgroundColor: '#FCEBC5'
                  },
                  cursor:
                    option === 'Share' && data?.share === false
                      ? 'not-allowed'
                      : ''
                }}
              >
                <ListItemIcon
                  sx={{
                    mr: -1.5
                  }}
                >
                  {option === 'Save to watch later' ||
                  option === 'Remove from library' ? (
                    <SvgIcon
                      sx={{ height: 16, width: 16, color: colorTextBlack }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.99967 4.00016V8.00016L10.6663 9.3335M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z"
                          stroke="#1F2933"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </SvgIcon>
                  ) : option === 'Share' ? (
                    <SvgIcon
                      sx={{ height: 16, width: 16, color: colorTextBlack }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.8599 7.40464C13.0227 7.26515 13.1041 7.1954 13.1339 7.1124C13.16 7.03955 13.16 6.95986 13.1339 6.88702C13.1041 6.80402 13.0227 6.73427 12.8599 6.59477L7.21278 1.75435C6.93263 1.51422 6.79255 1.39416 6.67396 1.39122C6.57089 1.38866 6.47244 1.43394 6.4073 1.51386C6.33236 1.60582 6.33236 1.79031 6.33236 2.15929V5.02279C4.90924 5.27176 3.60675 5.99288 2.63883 7.07562C1.58357 8.25605 0.999847 9.78367 0.999023 11.367V11.775C1.69858 10.9323 2.57203 10.2507 3.55953 9.77699C4.43015 9.35933 5.3713 9.11192 6.33236 9.04672V11.8401C6.33236 12.2091 6.33236 12.3936 6.4073 12.4856C6.47244 12.5655 6.57089 12.6108 6.67396 12.6082C6.79255 12.6053 6.93263 12.4852 7.21278 12.2451L12.8599 7.40464Z"
                          stroke="#1F2933"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </SvgIcon>
                  ) : option === 'Report' ? (
                    <SvgIcon
                      sx={{ height: 16, width: 16, color: colorTextBlack }}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.66699 10.0002C2.66699 10.0002 3.33366 9.3335 5.33366 9.3335C7.33366 9.3335 8.66699 10.6668 10.667 10.6668C12.667 10.6668 13.3337 10.0002 13.3337 10.0002V2.66683C13.3337 2.66683 12.667 3.3335 10.667 3.3335C8.66699 3.3335 7.33366 2.00016 5.33366 2.00016C3.33366 2.00016 2.66699 2.66683 2.66699 2.66683M2.66699 14.6668L2.66699 1.3335"
                          stroke="#1F2933"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </SvgIcon>
                  ) : (
                    ''
                  )}
                </ListItemIcon>
                {option}{' '}
                {(option === 'Save to watch later' ||
                  option === 'Remove from library') &&
                  isSaveToWatchLaterLoading && (
                    <CircularProgress
                      size={20}
                      sx={{ color: colorPrimary }}
                      style={{ marginLeft: '10px' }}
                    />
                  )}
              </MenuItem>
            </Tooltip>
          ) : (
            <MenuItem
              key={option}
              onClick={e => {
                e.stopPropagation();
                handleMenuActions(e, option);
              }}
              sx={{
                fontWeight: '600',
                fontSize: '14px',
                color: colorTextBlack,
                '&:hover': {
                  backgroundColor: '#FCEBC5'
                },
                cursor:
                  option === 'Share' && data?.share === false
                    ? 'not-allowed'
                    : ''
              }}
            >
              <ListItemIcon
                sx={{
                  mr: -1.5
                }}
              >
                {option === 'Save to watch later' ||
                option === 'Remove from library' ? (
                  <SvgIcon
                    sx={{ height: 16, width: 16, color: colorTextBlack }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.99967 4.00016V8.00016L10.6663 9.3335M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z"
                        stroke="#1F2933"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                ) : option === 'Share' ? (
                  <SvgIcon
                    sx={{ height: 16, width: 16, color: colorTextBlack }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.8599 7.40464C13.0227 7.26515 13.1041 7.1954 13.1339 7.1124C13.16 7.03955 13.16 6.95986 13.1339 6.88702C13.1041 6.80402 13.0227 6.73427 12.8599 6.59477L7.21278 1.75435C6.93263 1.51422 6.79255 1.39416 6.67396 1.39122C6.57089 1.38866 6.47244 1.43394 6.4073 1.51386C6.33236 1.60582 6.33236 1.79031 6.33236 2.15929V5.02279C4.90924 5.27176 3.60675 5.99288 2.63883 7.07562C1.58357 8.25605 0.999847 9.78367 0.999023 11.367V11.775C1.69858 10.9323 2.57203 10.2507 3.55953 9.77699C4.43015 9.35933 5.3713 9.11192 6.33236 9.04672V11.8401C6.33236 12.2091 6.33236 12.3936 6.4073 12.4856C6.47244 12.5655 6.57089 12.6108 6.67396 12.6082C6.79255 12.6053 6.93263 12.4852 7.21278 12.2451L12.8599 7.40464Z"
                        stroke="#1F2933"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                ) : option === 'Report' ? (
                  <SvgIcon
                    sx={{ height: 16, width: 16, color: colorTextBlack }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.66699 10.0002C2.66699 10.0002 3.33366 9.3335 5.33366 9.3335C7.33366 9.3335 8.66699 10.6668 10.667 10.6668C12.667 10.6668 13.3337 10.0002 13.3337 10.0002V2.66683C13.3337 2.66683 12.667 3.3335 10.667 3.3335C8.66699 3.3335 7.33366 2.00016 5.33366 2.00016C3.33366 2.00016 2.66699 2.66683 2.66699 2.66683M2.66699 14.6668L2.66699 1.3335"
                        stroke="#1F2933"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                ) : (
                  ''
                )}
              </ListItemIcon>
              {option}{' '}
              {(option === 'Save to watch later' ||
                option === 'Remove from library') &&
                isSaveToWatchLaterLoading && (
                  <CircularProgress
                    size={20}
                    sx={{ color: colorPrimary }}
                    style={{ marginLeft: '10px' }}
                  />
                )}
            </MenuItem>
          )
        )}
      </Menu>

      <ShareButtonDialog
        isOpen={isShareDialogOpen}
        onClose={handleCloseShareDialog}
        data={data}
      />

      <ReportModal
        isOpen={isReportDialogOpen}
        onClose={handleCloseReportDialog}
        submitData={data}
      />

      {showError && <SnackBarBox type={'error'} message={showError} />}
    </>
  );
}

export default MoreActionsComponent;
